import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconPencil({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill={color} fillRule='nonzero'>
                <path d='M12.243 2.929l-8.957 8.957-.471 3.3 3.3-.472 8.956-8.957-2.828-2.828zM12.95.808l4.242 4.242a1 1 0 0 1 0 1.414l-9.9 9.9a1 1 0 0 1-.565.283l-4.95.707a1 1 0 0 1-1.13-1.131l.706-4.95a1 1 0 0 1 .283-.566l9.9-9.9a1 1 0 0 1 1.414 0z' />
                <path d='M9.414 5.757l2.829 2.829 1.414-1.414-2.829-2.829z' />
            </g>
        </svg>
    );
}
